import { NavLink, Outlet } from "react-router-dom";

const NAV_ITEMS = [
	{ to: "marketing", label: "Marketing" },
	{ to: "terms", label: "Terms" },
	{ to: "privacy", label: "Privacy" },
	{ to: "support", label: "Support" },
];

export function Layout() {
	return (
		<div className="app-shell">
			<header className="site-header">
				<NavLink className="site-logo" to="marketing">
					QuickID
				</NavLink>
				<nav className="site-nav">
					{NAV_ITEMS.map((item) => (
						<NavLink
							key={item.to}
							to={item.to}
							className={({ isActive }) =>
								isActive ? "nav-link nav-link--active" : "nav-link"
							}
						>
							{item.label}
						</NavLink>
					))}
				</nav>
			</header>
			<main className="site-main">
				<Outlet />
			</main>
			<footer className="site-footer">
				© {new Date().getFullYear()} Monello Inc. All rights reserved.
			</footer>
		</div>
	);
}

export default Layout;
